<template>
  <footer
    class="bg-amber-300
             text-2xl text-center
             fixed
             mt-4
             inset-x-0
             bottom-0
             p-4">
    Made with <i class="fa-solid text-red-700 fa-heart"></i> by Ithiel <a href="https://github.com/ithiel883"> <i class="fa-brands text-red-700 fa-github"></i></a> <a href="https://www.linkedin.com/in/david-ajuka-630660144/"><i class="fa-brands text-red-700 fa-linkedin"></i></a>
  </footer>
</template>

<script>
export default {
  name: 'FooterComp'
}
</script>

<style scoped>

</style>
